import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-portal-promoted-info',
  templateUrl: './portal-promoted-info.component.html',
  styleUrls: ['./portal-promoted-info.component.scss']
})
export class PortalPromotedInfoComponent {
  @Input() data: any;
}
